export const ID_PIX_TYPES = {
  STRING: 'pages.campaign-settings.external-user-id-types.string',
  EMAIL: 'pages.campaign-settings.external-user-id-types.email',
};
